// removed by extract-text-webpack-plugin
module.exports = {"modal":"Feedback__modal___1S1jc","overlay":"Feedback__overlay___1fGvt","inner":"Feedback__inner___3KhO8","title":"Feedback__title___HpFxY","description":"Feedback__description____qQTG","buttons":"Feedback__buttons___3rTsA","fieldset":"Feedback__fieldset___1bxqt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Modals/Feedback/Feedback.scss
// module id = 1269
// module chunks = 1